'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp2;

var _reactBootstrap = require('react-bootstrap');

var _utils = require('helpers/utils');

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    PassRecoveryStepTwoView: {
        displayName: 'PassRecoveryStepTwoView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/PassRecovery/PassRecoveryStepTwo/default/PassRecoveryStepTwoView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var PassRecoveryStepTwoView = _wrapComponent('PassRecoveryStepTwoView')((_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(PassRecoveryStepTwoView, _Component);

    function PassRecoveryStepTwoView() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, PassRecoveryStepTwoView);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PassRecoveryStepTwoView.__proto__ || (0, _getPrototypeOf2.default)(PassRecoveryStepTwoView)).call.apply(_ref, [this].concat(args))), _this), _this.showAlert = function (alert) {
            var _this$props = _this.props,
                error = _this$props.error,
                errorCode = _this$props.errorCode,
                lang = _this$props.lang;


            if (error) {
                if (errorCode === null || errorCode === undefined) {
                    return _react3.default.createElement(
                        _reactBootstrap.Alert,
                        { bsStyle: 'danger', className: 'inner-right-xs' },
                        lang['store.common.server_is_unavailable']
                    );
                } else {
                    return _react3.default.createElement(
                        _reactBootstrap.Alert,
                        { bsStyle: 'danger', className: 'inner-right-xs' },
                        lang[error]
                    );
                }
            } else if (_this.props.alert || alert) {
                var _ref2 = _this.props.alert || alert,
                    message = _ref2.message,
                    style = _ref2.style;

                return _react3.default.createElement(
                    _reactBootstrap.Alert,
                    { bsStyle: style || 'danger', className: 'inner-right-xs' },
                    message
                );
            }

            return '';
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(PassRecoveryStepTwoView, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                isEmail = _props.isEmail,
                lang = _props.lang;

            return _react3.default.createElement(
                _components2.Preloader,
                { preload: this.props.preload },
                this.props.outerAlert ? this.showAlert(this.props.outerAlert) : this.showAlert(),
                _react3.default.createElement(
                    'main',
                    { id: 'authentication' },
                    _react3.default.createElement(
                        'div',
                        { className: 'container__' },
                        _react3.default.createElement(
                            'div',
                            { className: 'row' },
                            _react3.default.createElement(
                                'div',
                                { className: 'col-md-12' },
                                _react3.default.createElement(
                                    'section',
                                    { id: 'auth-form', className: 'sign-in' },
                                    _react3.default.createElement(
                                        'div',
                                        { className: 'bordered' },
                                        _react3.default.createElement(
                                            'form',
                                            { name: 'sms', autoComplete: 'sms-code', className: 'login-form', onSubmit: this.props.onSubmit },
                                            _react3.default.createElement(
                                                _reactBootstrap.FormGroup,
                                                { controlId: 'sms' },
                                                isEmail ? _react3.default.createElement(
                                                    _reactBootstrap.ControlLabel,
                                                    { htmlFor: 'sms' },
                                                    lang['store.password_recovery.code_from_email']
                                                ) : _react3.default.createElement(
                                                    _reactBootstrap.ControlLabel,
                                                    { htmlFor: 'sms' },
                                                    lang['store.password_recovery.code_from_sms']
                                                ),
                                                _react3.default.createElement(_reactBootstrap.FormControl, {
                                                    autoComplete: 'sms-code',
                                                    type: (0, _utils.isMobileDevice)() ? "number" : "text",
                                                    name: 'SMS',
                                                    placeholder: '1234',
                                                    pattern: '\\d*',
                                                    value: this.props.code,
                                                    onChange: function onChange(e) {
                                                        if ((0, _utils.validateNumeric)(e.target.value)) {
                                                            _this2.props.changeFieldCode(e);
                                                        }
                                                    }
                                                })
                                            ),
                                            _react3.default.createElement(
                                                _reactBootstrap.FormGroup,
                                                { controlId: 'pass_new' },
                                                _react3.default.createElement(
                                                    _reactBootstrap.ControlLabel,
                                                    { htmlFor: 'pass_new' },
                                                    lang['store.password_recovery.new_password']
                                                ),
                                                _react3.default.createElement(_reactBootstrap.FormControl, {
                                                    autoComplete: 'pass-code',
                                                    type: 'password',
                                                    name: 'pass_new',
                                                    value: this.props.password,
                                                    onChange: this.props.changeFieldPassword,
                                                    placeholder: lang['login.password']
                                                })
                                            ),
                                            _react3.default.createElement(
                                                _reactBootstrap.FormGroup,
                                                null,
                                                _react3.default.createElement(
                                                    _reactBootstrap.Button,
                                                    {
                                                        type: 'submit',
                                                        bsStyle: 'primary',
                                                        className: 'form-control',
                                                        disabled: this.props.disabledSubmit
                                                    },
                                                    lang['store.password_recovery.change_password']
                                                )
                                            ),
                                            isEmail ? null : _react3.default.createElement(_components2.VoiceCode, {
                                                login: this.props.login,
                                                source: 'restore_password',
                                                showAlert: this.props.showOuterAlert,
                                                whiteList: true
                                            })
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);
    return PassRecoveryStepTwoView;
}(_react2.Component), _class.propTypes = {
    alert: _react2.PropTypes.shape({
        message: _react2.PropTypes.string,
        style: _react2.PropTypes.string,
        lang: _react2.PropTypes.object
    })
}, _temp2));

exports.default = PassRecoveryStepTwoView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PassRecovery/PassRecoveryStepTwo/default/PassRecoveryStepTwoView.jsx
// module id = 1727
// module chunks = 0